import ApiSlice from '../services/api/ApiSlice';
import { store } from './index';

class ReduxHooks {
  /**
   * Dispatch an action to redux reducers so that they update the state
   * @dispatch dispatch
   */
  dispatch = (action) => {
    store.dispatch(action);
  };

  /**
   * Return the current state of the store
   * @dispatch getStore
   */
  getStore = () => store.getState();

  /**
   * Clear redux store
   * @method clearReduxStore
   */
  clearReduxStore = () => {
    store.dispatch({ type: 'RESET_STORE' });
    // RESET_STORE wipes the api reducer's state but not the middleware's subscription
    // bookkeeping, which would otherwise refetch the previous user's data.
    store.dispatch(ApiSlice.util.resetApiState());
  };

  /**
   * Dispatch multiple actions. React 18+ automatically batches dispatches into a
   * single rerender, so no explicit batch() wrapper is needed.
   * @method batchActions
   */
  batchActions = (actionArray) => {
    actionArray.forEach((action) => {
      store.dispatch(action);
    });
  };
}
export default new ReduxHooks();
